import UploadNda from './UploadNda.component';

export default UploadNda;
